<div
  class="wrapper"
  [class.wrapper__active]="isInputActive"
  [class.wrapper__inactive]="!isInputActive"
  [class.disabled]="disableField"
>
  <mat-form-field [floatLabel]="floatLabel" cropFieldLabel>
    <mat-label>
      <span class="tw-flex tw-items-center">
        <span class="tw-overflow-hidden tw-text-ellipsis">
          {{ label | translate }} {{ isFieldRequired(ngControl.control) }}
        </span>

        <ng-container *ngIf="tooltipText">
          <ui-svg-icon
            [name]="iconNames.QuestionFrame"
            [matTooltip]="tooltipText | translate"
            class="help-icon__with-height tw-ml-1"
          ></ui-svg-icon>
        </ng-container>
      </span>
    </mat-label>
    <input
      matInput
      #phoneNumberInput
      type="tel"
      autocomplete="off"
      [ngClass]="disableField ? 'phone-input__disabled' : 'phone-input'"
      [mask]="defaultMask"
      [validation]="false"
      [formControl]="phoneNumberControl"
      [attr.test-id]="testId"
    />
    <ui-svg-icon
      *ngIf="!showCheckmark"
      [name]="iconNames.Close"
      class="tw-text-red-600 pointer reset-button"
      [class.reset-button__hidden]="!isInputActive && hasClicked"
      [class.reset-button__hidden-started]="!hasClicked && !isInputActive"
      [class.reset-button__visible]="isInputActive"
      (click)="onClearButtonClick()"
      matSuffix
    ></ui-svg-icon>
    <ui-svg-icon
      *ngIf="showCheckmark"
      [name]="iconNames.Checkmark"
      class="tw-text-light-green-500"
      (click)="onSaveButtonClick()"
      matSuffix
    ></ui-svg-icon>
    <span matPrefix>
      <div
        class="reset-button"
        [class.country-code__hidden]="!isInputActive && hasClicked"
        [class.country-code__hidden-started]="!hasClicked && !isInputActive"
        [class.country-code__visible]="isInputActive"
      >
        <ui-country-code
          [formControl]="countryCodeControl"
          [isMiniForm]="true"
          (selected)="onCountryCodeChanged($event)"
        ></ui-country-code>
      </div>
    </span>

    <mat-error *ngIf="isFieldInvalid">{{ 'common.validation.error.required' | translate }} </mat-error>
  </mat-form-field>
</div>
